import { Box } from "@mui/material";
import { PieChart } from "@mui/x-charts";
import styles from "./styles.module.scss";
import { TEST_CASE_STATUS } from "../../constants";

const TestCaseCharts = ({ testCasesData, testCasesTotal, draftTestCases }) => {
    const pendingTotal = testCasesData.filter(
        (testCase) => testCase.status === TEST_CASE_STATUS.pending
    ).length;
    const draftPercent = Number(
        ((draftTestCases.length / testCasesTotal) * 100).toFixed(2)
    );
    const notStartedTotal = draftTestCases.length + pendingTotal;
    const notStartedPercent = Number(
        ((notStartedTotal / testCasesTotal) * 100).toFixed(2)
    );
    const executedPercent = Number((100 - notStartedPercent).toFixed(2));

    const runningTotal = testCasesData.filter(
        (testCase) => testCase.status === TEST_CASE_STATUS.running
    ).length;
    const runningPercent = Number(
        ((runningTotal / testCasesTotal) * 100).toFixed(2)
    );

    const failedTotal = testCasesData.filter(
        (testCase) =>
            testCase.status === TEST_CASE_STATUS.failed ||
            testCase.status === TEST_CASE_STATUS.initialFailure
    ).length;
    const failedPercent = Number(
        ((failedTotal / testCasesTotal) * 100).toFixed(2)
    );

    const passedTotal = testCasesData.filter(
        (testCase) => testCase.status === TEST_CASE_STATUS.completed
    ).length;
    const passedPercent = Number(
        ((passedTotal / testCasesTotal) * 100).toFixed(2)
    );
    const pendingPercent = Number(
        ((pendingTotal / testCasesTotal) * 100).toFixed(2)
    );

    const executionData = [
        { label: "Executed", value: executedPercent, color: "#ab47bc" },
        { label: "Not Started", value: notStartedPercent, color: "#78909c" },
    ].filter((item) => Number(item.value) > 0);

    const statusData = [
        { label: "Passed", value: passedPercent, color: "#388e3c" },
        { label: "In Progress", value: runningPercent, color: "#2196f3" },
        { label: "Pending", value: pendingPercent, color: "#F0AD4E" },
        { label: "Failed", value: failedPercent, color: "#d32f2f" },
        { label: "Draft", value: draftPercent, color: "#bdbdbd" },
    ].filter((item) => Number(item.value) > 0);

    return (
        <Box className={styles.container}>
            <Box className={styles.chartsWrapper}>
                <Box>
                    <PieChart
                        series={[
                            {
                                innerRadius: 75,
                                outerRadius: 100,
                                data: executionData,
                                paddingAngle: 4,
                                valueFormatter: (item) => `${item.value}%`,
                            },
                        ]}
                        width={460}
                        height={240}
                        slotProps={{
                            legend: {
                                itemGap: 30,
                            },
                        }}
                    />
                </Box>
                <Box>
                    <PieChart
                        series={[
                            {
                                innerRadius: 75,
                                outerRadius: 100,
                                data: statusData,
                                paddingAngle: 4,
                                valueFormatter: (item) => `${item.value}%`,
                            },
                        ]}
                        width={460}
                        height={240}
                        slotProps={{
                            legend: {
                                itemGap: 30,
                            },
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default TestCaseCharts;
